<template>
  <div class="js-accordion">
    <button
      type="button"
      class="js-accordion--trigger"
      :class="{ '_state-open': isOpened }"
      @click="accordionToggle()"
    >
      <span class="area-label">{{ area }}</span>
      <span class="js-accordion-sign"></span>
    </button>
    <div
      v-if="isOpened"
      class="js-accordion--target"
      :class="{ 'state-open': isOpened }"
    >
      <div class="js-accordion--body">
        <div
          v-for="(masterbook, index) in master_books"
          :key="index"
          class="masterbook_division"
          @click="goToBook(masterbook)"
        >
          <div v-if="masterbook.purchase_available">
            <ItemIndexMasterBook
              :image-url="masterbook.content.ticket_image_url"
              :name="masterbook.name"
              :price="masterbook.display_price"
            />
          </div>
          <div class="cb"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Vue
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";

import masterBookService from "@/services/masterBook";
import nativeHandlerService from "@/services/nativeHandler";

export default {
  name: "ItemAccordion",

  props: {
    master_books: {
      type: Array,
      required: true,
    },
    area: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const isOpened = ref(true);

    onMounted(() => {
      console.log(
        "sessionStorage.hasOwnProperty :>> ",
        sessionStorage.hasOwnProperty(props.area)
      );
      if (sessionStorage.hasOwnProperty(props.area)) {
        isOpened.value = false;
      }
    });

    const goToBook = (masterBook) => {
      masterBookService.goToBook(masterBook, router);
    };

    const accordionToggle = () => {
      if (sessionStorage.hasOwnProperty(props.area)) {
        sessionStorage.removeItem(props.area);
      } else {
        sessionStorage.setItem(props.area, false);
      }
      isOpened.value = !isOpened.value;
    };

    return {
      isOpened,
      goToBook,
      accordionToggle,
    };
  },
};
</script>

<style lang="scss" scoped>
*:focus {
  /* buttonタグをタップしたときChromeだと枠線が表示されてしまうのを防止
    https://kakedashiweb.site/archives/790
    */
  outline: none;
}

.js-accordion--trigger {
  width: 100%;
  height: 36px;
  background: #fdd000;
  border: none;
  border-top: 2px solid #ffb206;
  border-bottom: 2px solid #ffb206;
  padding-top: 5px;
  font-size: 13px;
  font-weight: bold;
  position: relative;
}

.area-label {
  position: absolute;
  top: 50%;
  left: 3%;
  color: #000000;
  transform: translate(0%, -50%);
  -webkit-transform: translate(0%, -50%);
  -ms-transform: translate(0%, -50%);
}

.js-accordion-sign {
  float: right;
  background-repeat: no-repeat;
  width: 20px;
  height: 20px;
  background-image: url(~@/assets/img/icon/png/angle-right.png);
  background-size: 6px auto;
  background-position: 7px 3px;
}

._state-open .js-accordion-sign {
  background-image: url(~@/assets/img/icon/png/angle-down.png);
  background-size: 10px auto;
  background-position: 5px 5px;
}

.cb {
  clear: both;
}
</style>
